export const fontSizeBase = 16;
export const colorNeutral15 = "#D8D8D8";
export const colorNeutral20 = "#DBD7D3";
export const colorNeutral30 = "#B2B2B2";
export const colorNeutral40 = "#90969A";
export const colorNeutral60 = "#5E666B";
export const colorNeutral80 = "#2F3A40";
export const colorNeutralDefault = "#001219";
export const colorNeutralWhite = "#FFFFFF";
export const colorNeutral02 = "#FBFBFB";
export const colorNeutral03 = "#F6F7F7";
export const colorNeutral05 = "#F2F2F2";
export const colorBrand1Active = "#003242";
export const colorBrand1Base = "#004455";
export const colorBrand1Hover = "#255564";
export const colorBrand1Tint = "#F2F5F6";
export const colorBrand1Highlight = "#DAE3E6";
export const colorBrand2Active = "#F67748";
export const colorBrand2Base = "#F99F7E";
export const colorBrand2Hover = "#FAB297";
export const colorBrand2Tint = "#FFF5F2";
export const colorActionActive = "#085073";
export const colorActionBase = "#117EAC";
export const colorActionHover = "#63B2D3";
export const colorActionTint = "#F9FAFD";
export const colorMessageSuccessBase = "#048106";
export const colorMessageSuccessHover = "#006900";
export const colorMessageSuccessTint = "#F8FBF7";
export const colorMessageWarningBase = "#FCBF38";
export const colorMessageWarningHover = "#E2B027";
export const colorMessageWarningTint = "#FFFDF9";
export const colorMessageErrorBase = "#B93646";
export const colorMessageErrorHover = "#FCEDED";
export const colorMessageErrorTint = "#FEF9F9";
export const colorDecPurple10 = "#f0e9f4";
export const colorDecPurple15 = "#ebe4f0";
export const colorDecPurple100 = "#ba8ecc";
export const colorDecPurple150 = "#4e3b5e";
export const colorDecTurquoise10 = "#d7e9eb";
export const colorDecTurquoise20 = "#bad6de";
export const colorDecTurquoise30 = "#98c4cb";
export const colorDecTurquoise40 = "#6ba8ad";
export const colorDecTurquoise60 = "#007a84";
export const colorDecTurquoise80 = "#007a85";
export const colorDecTurquoise100 = "#005d66";
export const colorDecTurquoise03 = "#f2fafc";
export const colorDecTurquoise05 = "#e5f0f1";
export const colorDecIndigo05 = "#f3f4f9";
export const colorDecIndigo10 = "#e7e9f4";
export const colorDecIndigo15 = "#dfe1ef";
export const colorDecIndigo30 = "#c5c9e1";
export const colorDecIndigo50 = "#6069a8";
export const colorDecIndigo60 = "#4c5693";
export const colorDecIndigo80 = "#38427f";
export const colorDecIndigo100 = "#818ece";
export const colorDecIndigo200 = "#565F82";
export const colorDecBlue10 = "#d6e4ef";
export const colorDecBlue15 = "#e2edf3";
export const colorDecBlue100 = "#326eb1";
export const colorDecCyan10 = "#d0eef3";
export const colorDecCyan100 = "#23accb";
export const colorDecKelly03 = "#e3edec";
export const colorDecKelly10 = "#c8f0e8";
export const colorDecKelly100 = "#0fb689";
export const colorDecGreen10 = "#e7f3f0";
export const colorDecGreen15 = "#d8ece7";
export const colorDecGreen30 = "#77bba9";
export const colorDecGreen50 = "#088463";
export const colorDecGreen60 = "#00664b";
export const colorDecGreen100 = "#4BA039";
export const colorDecYellow02 = "#FFFBF5";
export const colorDecYellow03 = "#f5f0e8";
export const colorDecYellow10 = "#faf2d4";
export const colorDecYellow15 = "#fef0cf";
export const colorDecYellow40 = "#f1d77d";
export const colorDecYellow60 = "#fcbf38";
export const colorDecYellow100 = "#eec331";
export const colorDecOrange10 = "#fae1cd";
export const colorDecOrange100 = "#eb561d";
export const colorDecRed10 = "#fadddb";
export const colorDecRed15 = "#f5e0dc";
export const colorDecRed60 = "#be4025";
export const colorDecRed70 = "#982c0e";
export const colorDecRed100 = "#e9453e";
export const colorDecBrown100 = "#8e4f17";
export const colorDecBlack30 = "#161616";
export const colorDecSandElevationMinus1 = "#e7dbd0";
export const colorDecSandElevation0 = "#f3eee9";
export const colorDecSandElevation1 = "#fdfbf7";
export const colorDecSandElevation2 = "#fffefd";
export const colorAccessibilityFocusDefault = "#009ea8";
export const elevation01 = "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)";
export const elevation04 = "0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)";
export const elevation08 = "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.2)";
export const spacing00 = "0px";
export const spacing01 = "0.25rem";
export const spacing02 = "0.5rem";
export const spacing03 = "1rem";
export const spacing04 = "1.5rem";
export const spacing05 = "2rem";
export const spacing06 = "2.5rem";
export const spacing07 = "3rem";
export const spacing08 = "3.5rem";
export const fontFamilyProximaNova = "proxima-nova";
export const fontFamilyTobias = "tobias";
export const fontFamilyPPEditorialNew = "pp-editorial-new";
export const fontFamilyFallback = "Arial";
export const fontLetterSpacing00 = "normal";
export const fontLetterSpacing01 = "0.005em";
export const fontLetterSpacing02 = "0.01em";
export const fontLetterSpacing03 = "0.0125em";
export const fontLetterSpacing04 = "0.0325em";
export const fontLineHeight10 = "3.5rem";
export const fontLineHeight01 = "0.875rem";
export const fontLineHeight02 = "1rem";
export const fontLineHeight03 = "1.125rem";
export const fontLineHeight04 = "1.25rem";
export const fontLineHeight05 = "1.375rem";
export const fontLineHeight06 = "1.5rem";
export const fontLineHeight07 = "1.75rem";
export const fontLineHeight08 = "2rem";
export const fontLineHeight09 = "2.25rem";
export const fontSize01 = "0.625rem";
export const fontSize02 = "0.75rem";
export const fontSize03 = "0.875rem";
export const fontSize04 = "1rem";
export const fontSize05 = "1.125rem";
export const fontSize06 = "1.25rem";
export const fontSize07 = "1.5rem";
export const fontSize08 = "1.75rem";
export const fontSize09 = "2.25rem";
export const fontSize10 = "3rem";
export const fontWeightLight = "300";
export const fontWeightNormal = "400";
export const fontWeightMedium = "500";
export const fontWeightSemibold = "600";
export const fontWeightBold = "700";
export const breakpointXs = "599px";
export const breakpointSm = "959px";
export const breakpointMd = "1439px";
export const breakpointLg = "1919px";
export const mediaQueryExpressionAll = "all";
export const mediaQueryExpressionPrint = "print";
export const mediaQueryExpressionScreen = "screen";
export const mediaQueryExpressionSpeech = "speech";
export const mediaQueryExpressionLandscape = "'(orientation: landscape)'";
export const mediaQueryExpressionPortrait = "'(orientation: portrait)'";
export const mediaQueryUnitIntervalsPx = "1";
export const mediaQueryUnitIntervalsEm = "0.01";
export const mediaQueryUnitIntervalsRem = "0.1";
export const borderRadius00 = "0";
export const borderRadius01 = "0.125rem";
export const borderRadius02 = "0.25rem";
export const borderRadius03 = "0.5rem";
export const borderRadius04 = "1rem";
export const borderRadius045 = "1.25rem";
export const borderRadius05 = "1.5rem";
export const borderRadiusFull = "50%"; 